/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyGroupingRuleRejectRequest {
    getFixupPrototypeFunction() { return CostAnomalyGroupingRuleRejectRequest.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyGroupingRuleRejectRequest>): CostAnomalyGroupingRuleRejectRequest {
        let obj = Object.assign(new CostAnomalyGroupingRuleRejectRequest(), model);
        CostAnomalyGroupingRuleRejectRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyGroupingRuleRejectRequest>): CostAnomalyGroupingRuleRejectRequest {
        if (!model) return null;
        return CostAnomalyGroupingRuleRejectRequest.newInstance(<CostAnomalyGroupingRuleRejectRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyGroupingRuleRejectRequest) {
        if (!obj) return;

        models.CostAnomalyGroupingRuleRejectRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyGroupingRuleRejectRequest): boolean {
        Object.setPrototypeOf(obj, CostAnomalyGroupingRuleRejectRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.reject_until === "string") {
            this.reject_until = new Date(<string><any>this.reject_until);
        }
        if (typeof this.bill_date === "string") {
            this.bill_date = new Date(<string><any>this.bill_date);
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Dimension ID
     */
    dimension_id: string;

    /**
     * Grouping Rule ID
     */
    grouping_rule_id: string;

    /**
     * Reject Until time for the anomaly
     */
    reject_until: Date;

    /**
     * Rejected Reason
     */
    reject_reason: string;

    /**
     * Product Category
     */
    product_category: string;

    /**
     * Resource Category
     */
    resource_category: string;

    /**
     * Bill date in yyyy-mm-dd format
     */
    bill_date: Date;

    /**
     * Billing Currency
     */
    currency: models.Currency;

}
